<template>
    <v-container fluid>
        <h3>Fingerprint Get Auth</h3>
        <v-row>
            <v-col>
                <div title="Fingerprint Get Auth">
                    <template>
                        <v-text-field v-model="authCode" label="Auth Code" />
                    </template>
                    <div>
                        <v-btn color="primary" @click="getAuthCode">Get Auth</v-btn>
                    </div>
                    <template>
                        <div v-if="results">
                            <p>Auth Code: {{ results.authCode }}</p>
                        </div>
                    </template>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import lookupsGets from "@/mixins/lookupsGets";
const AUTHENTICATION_TYPE_IDENTIFIER = '__fingerprint__';

export default {
    data() {
        return {
            authCode: '',
            results: null
        };
    },
    computed: {
        appVersion() {
            return this.$store.state.appVersion;
        },
        loginCall() {
            return this.$store.state.loginCall;
        },
        geolocation() {
            return this.$store.state.geolocation;
        }
    },
    methods: {
        async getAuthCode() {
            let params = { uuid: this.authCode };
            params = {
                  ...params,
                  domain: window.location.hostname,
                  app_version: this.appVersion,
                  login: true,
                  latitude: undefined,
                  longitude: undefined,
                  identifier: AUTHENTICATION_TYPE_IDENTIFIER
                }
            try {
                  this.pwaRemotePost('get_fingerprint_auth', params)
                  .then( results => {
                    if(results != null) {
                      console.log("results: ", results)
                      this.results = results;
                      this.progress = results.done_at
                      this.verificationUuid = results.customer
                      this.$emit('input', this.verificationUuid)
                    }
                  })
                console.log("Auth code fetched successfully:", this.results);
              } catch (error) {
                console.error("Error fetching auth code:", error);
              }
        }
    },
    mixins: [lookupsGets]
};

</script>